<template>
    <div>
       <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="封面图">
              <el-upload
                :action="uploadImgUrl"
                name='image'
                :data="{extra:'headimg',type:'default'}"
                list-type="picture-card"
                :limit='1'
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-success='handleUploadOK'
                :on-exceed='handleExceed'
                :file-list="filelist['headimg']"	
                >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
          </el-form-item>
          <el-form-item label="标题">
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item label="首页位置">
            <el-select v-model="form.type" placeholder="请选择">
              <el-option
                v-for="item in typelist"
                :key="item.val"
                :label="item.name"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转类别">
            <el-select v-model="form.linktype" placeholder="请选择">
              <el-option
                v-for="item in linktypelist"
                :key="item.val"
                :label="item.name"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跳转目标">
            <el-select v-model="form.link" placeholder="请选择">
              <el-option
                v-for="item in linklist[form.linktype]"
                :key="item.id"
                :label="item.name"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置号">
            <el-input v-model="form.position"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSave">立即保存</el-button>
            <el-button @click='goBack'>取消</el-button>
          </el-form-item>
        </el-form>
    </div>  
</template>
<script>
  export default {
    
    data() {
      return {
        form: {
          id:'',
          title: '',
          type: '',
          linktype:1,
          link:'',
          headimg:[],
          position:''
        },
        uploadImgUrl:process.env.VUE_APP_API+"/upload/uploadImg",
        dialogImageUrl: '',
        dialogVisible: false,
        processing:false,
        filelist:[],

        typelist:[],
        linktypelist:[],
        linklist:[]
      }
    },
    created(){
          this.form.id=this.$route.query.contentid==undefined?0:this.$route.query.contentid
          this.initContent(this.form.id)
    },
    methods: {
      onSave() {
          if(this.processing){
             this.$message.error("请等待处理完成");return false
          }
          if(this.form.headimg.length<=0){
            this.$message.error("请上传图片");return false
          }
          if(this.form.title==''){
            this.$message.error("内容标题不能为空");return false
          }
          if(this.form.type==''){
            this.$message.error("请选择首页位置");return false
          }
          if(this.form.linktype==''){
            this.$message.error("请选择跳转类别");return false
          }
          if(this.form.link==''){
            this.$message.error("请选择跳转目标");return false
          }
          if(this.form.position==''|| isNaN(this.form.position) ){
            this.$message.error("请输入位置号");return false
          }
          this.form.headimg=this.form.headimg[0]
          this.processing=true
          
          this.$post("/index/saveContent",{contentinfo:this.form}).then((data)=>{
               if(data.result.success){
                   this.$message({message:data.result.info,type:'success'})
                   setTimeout(()=>{this.$router.push('/indexlist')},500)
               }else{
                   this.$message.error(data.result.info)
               }
               this.processing=false
          })
      },
      initContent(id){
          this.$post("/index/initContent",{id:id}).then((data)=>{
              if(this.form.id>0){
                 this.form=data.result.info.contentinfo
              }
              this.filelist=data.result.info.filelist
              this.typelist=data.result.info.typelist
              this.linktypelist=data.result.info.linktypelist
              this.linklist=data.result.info.linklist
          })
      },
      goBack(){
          this.$go("/indexlist")
      },
      handleRemove(file, fileList) {
        let type=file.response.result.info.extra
        switch(type){
          case 'headimg':
                this.form.headimg=this.getSlides(fileList);break;
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;  
          default:
                this.$message("图片类型错误");      
        }
      },
      handleUploadOK(response, file, fileList){
        let type=response.result.info.extra
        switch(type){
          case 'headimg':  
                this.form.headimg=this.getSlides(fileList);break;    
          case 'slides':
                this.form.slides=this.getSlides(fileList);break;
          default:
                this.$message("图片类型错误");      
        }
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      getSlides(fileList){
         return fileList.map((item)=>item.response.result.info.url)
      },
      handleExceed(){
         this.$message.error("超出最大上传数量");
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
